<template>
  <div>
    <b-card no-body>
      <b-tabs small card justified>
          <div>
            <pre>{{data.results}}</pre>
          </div>


      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {

  },
  props: {
    deviceID: '',
    data: {},
  },
  data() {
    return {


    }
  },

  created() {
    this.timer = setInterval(this.enableTimer, 1000);
  },

  methods: {

    makeToast(variant = null, message = null) {

      this.$bvToast.toast(message, {
        // title: `Config Updated ${variant || 'default'}`,
        title: `Notification:`,
        variant: variant,
        toaster: 'b-toaster-top-center',
        solid: true
      });
      // toast.show();
    },
    sendCmd(id, op) {

      let uri = `/api/devices/${this.deviceID}/op?op=${op}`;
      axios.get(uri).then((response) => {


        if (response.data.success === true) {
          this.makeToast('info', 'Router updated.');
          setTimeout(() => { console.log("World!"); }, 3000);
          window.location.reload();
          // this.$forceUpdate();
        } else {
          this.makeToast('danger', 'Unable to update device.');
        }

      });
    },
  }

};
</script>
